// FIN-HUBS: Cadastros — Contas & Saldos + Categorias + Centros de Custo.
// Profissionais morou aqui até 24/08/2026; hoje é a vista única do hub RH
// (/administrativo/rh, sem abas desde 25/08) — o redirect no App.tsx leva pra lá.
import { Navigate, useSearchParams } from 'react-router-dom';
import HubAbas, { HubTab } from '../../components/HubAbas';
import ContasFinanceiras from '../ContasFinanceiras';
import Categorias from '../Categorias';
import CentrosCusto from '../CentrosCusto';
import FinanceiroAvisos from '../FinanceiroAvisos';
import FinanceiroFornecedores from '../financeiro-fornecedores/FinanceiroFornecedores';

const TABS: HubTab[] = [
  { key: 'contas',        label: 'Contas & Saldos',  perm: 'financeiro.contas.ver',        render: () => <ContasFinanceiras /> },
  { key: 'categorias',    label: 'Categorias',       perm: 'financeiro.categorias.ver',    render: () => <Categorias /> },
  { key: 'centros-custo', label: 'Centros de Custo', perm: 'financeiro.centros_custo.ver', render: () => <CentrosCusto /> },
  // Fornecedores (01/10/2026): ver, cadastrar, corrigir, juntar duplicados e
  // excluir. Até aqui, fornecedor só se cadastrava por DENTRO de uma despesa.
  { key: 'fornecedores',  label: 'Fornecedores',     perm: 'financeiro.fornecedores.ver',  render: () => <FinanceiroFornecedores /> },
  // Avisos (2026-09-01): quem recebe cada aviso automático do financeiro.
  // A perm das duas está no perms[] do fin-cadastros em App.tsx — menu-hubs.md.
  { key: 'avisos',        label: 'Avisos',           perm: 'financeiro.avisos.ver',        render: () => <FinanceiroAvisos /> },
];

export default function FinanceiroCadastrosHub() {
  // Link salvo de ANTES da mudança (?aba=profissionais) não pode cair em
  // silêncio na primeira aba — segue para o endereço novo. O hub RH virou
  // vista única (25/08): o ?aba= sai da query no destino, os demais params vão
  // junto.
  const [sp] = useSearchParams();
  if (sp.get('aba') === 'profissionais') {
    const destino = new URLSearchParams(sp);
    destino.delete('aba');
    const q = destino.toString();
    return <Navigate to={`/administrativo/rh${q ? `?${q}` : ''}`} replace />;
  }
  return <HubAbas tabs={TABS} />;
}
